export const PricingPlanValidateFields = (values) => {
    let errors = {};

    // Validate bundle categories and templates
    values.bundle.forEach((bundle, index) => {
        // Category Validation
        if (!bundle.category_id || !bundle.category_id._id) {
            if (!errors.bundle) errors.bundle = [];
            errors.bundle[index] = errors.bundle[index] || {};
            errors.bundle[index].category_id = "Category must be selected.";
        }

        // Template Validation
        if (!bundle.template_id || bundle.template_id.length === 0) {
            if (!errors.bundle) errors.bundle = [];
            errors.bundle[index] = errors.bundle[index] || {};
            errors.bundle[index].template_id = "At least one template must be selected.";
        }
    });

    return errors;
};
